import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
// import lang from '../../constants/Languages.js';

//img
import headingImg from '../../assets/icons/field-gray.svg';

const AboutHeadingsPage = ({ clang, title, desc, isWrongQuery, isLoading, isError }) => {
    return (
        <div className="characters__about-headings">
            {!isWrongQuery && !isLoading && !isError &&
            <div>
              <div className="characters-headings__header-container">
                  <img src={headingImg} alt="headings" className="characters__about-headings--img" alt=""/>
                  <h3 className="characters__about-headings--title" dangerouslySetInnerHTML={{__html: title}}></h3>
              </div>
              <div className="characters__about-headings--desc" dangerouslySetInnerHTML={{__html: desc}}></div>
              </div>}
        </div>
    );
};

AboutHeadingsPage.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(AboutHeadingsPage);



// WEBPACK FOOTER //
// ./src/components/characteristics/AboutHeadingsPage.js